// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"94c1265f","667":"3e7070af","950":"efe4a2a2","977":"75902e2e"}[chunkId] + ".chunk.js";
};